module.exports = __webpack_public_path__ + "src/assets/games/16/4.jpg";